import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const CandleBreakLine = ({
  candleDuration,
  breakBy,
  priceToBreakLong,
  priceToBreakShort,
  priceToBreak,
  quantityBasisValue,
  size,
  scaleY,
  portalRef
}) => {
  let bothDirections;
  if (priceToBreakLong > 0) bothDirections = true;
  else bothDirections = false;

  const json = {
    Category: 'Entry',
    Type: 'Candle Break',
    'Candle Duration': candleDuration,
    'Break By': breakBy,
    'Break Price': ApplyRounding(Number(priceToBreak), 2),
    'Quantity Basis': quantityBasisValue,
  };

  const jsonLong = {
    Category: 'Entry',
    Type: 'Candle Break',
    'Candle Duration': candleDuration,
    'Break By': breakBy,
    'Break Price Long': ApplyRounding(Number(priceToBreakLong), 2),
    'Quantity Basis': quantityBasisValue,
  };
  const jsonShort = {
    Category: 'Entry',
    Type: 'Candle Break',
    'Candle Duration': candleDuration,
    'Break By': breakBy,
    'Break Short': ApplyRounding(Number(priceToBreakShort), 2),
    'Quantity Basis': quantityBasisValue,
  };

  return (
    <>
      {scaleY ? (
        <>
          {bothDirections ? (
            <>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreakLong))}
                y2={scaleY(Number(priceToBreakLong))}
              ></line>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreakShort))}
                y2={scaleY(Number(priceToBreakShort))}
              ></line>
              <HoverBox
                json={jsonLong}
                topBoundary={scaleY(Number(priceToBreakLong)) - 2}
                bottomBoundary={scaleY(Number(priceToBreakShort)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
              />
              <HoverBox
                json={jsonShort}
                topBoundary={scaleY(Number(priceToBreakShort)) - 2}
                bottomBoundary={scaleY(Number(priceToBreakShort)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
              />
            </>
          ) : (
            <>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              ></line>
              <HoverBox
                json={json}
                topBoundary={scaleY(Number(priceToBreak)) - 2}
                bottomBoundary={scaleY(Number(priceToBreak)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
              />
            </>
          )}
        </>
      ) : null}
    </>
  );
};

CandleBreakLine.propTypes = {
  breakBy: PropTypes.number,
  candleDuration: PropTypes.number,
  priceToBreak: PropTypes.number,
  priceToBreakLong: PropTypes.number,
  priceToBreakShort: PropTypes.number,
  quantityBasisValue: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.number,
  portalRef: PropTypes.object
};
